var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34 14.1601H11.565C12.22 14.1601 12.77 13.6901 12.885 13.0651H4.435C3.14499 13.0651 2.095 12.0151 2.095 10.7251V3.95508C1.47 4.07507 1 4.62009 1 5.27509V12.8251C1 13.5601 1.60001 14.1601 2.34 14.1601Z",
    fill: "#1E4133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64014 8.69508L10.6601 6.95008L7.64014 5.20508V8.69508Z",
    fill: "#1E4133"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.66 1.83984H4.43497C3.69498 1.83984 3.09497 2.43985 3.09497 3.17484V10.7249C3.09497 11.4648 3.69498 12.0648 4.43497 12.0648H13.66C14.4 12.0648 15 11.4648 15 10.7249V3.17484C15 2.43985 14.4 1.83984 13.66 1.83984ZM11.28 7.74985L8.01996 9.62985C7.87497 9.71484 7.71497 9.75485 7.55997 9.75485C7.39996 9.75485 7.24496 9.71484 7.09998 9.62985C6.80997 9.46484 6.63998 9.16983 6.63998 8.83484V5.06485C6.63998 4.73483 6.80997 4.43484 7.09998 4.26984C7.38498 4.10483 7.72998 4.10483 8.01996 4.26984L11.28 6.15485C11.57 6.31985 11.74 6.61984 11.74 6.94983C11.74 7.28485 11.57 7.57983 11.28 7.74985Z",
    fill: "#1E4133"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/Videos.e1fc0c1d651c0ac83d26c5544369430f.svg";
export { ForwardRef as ReactComponent };